export const LYDIA_PAGE_AMOUNTS = ['1', '5', '10']

export const MONEY_POT_AMOUNTS = ['10', '20', '30']
